
<template>
  <div class="projects">
    <h1>Projects</h1>
    <Grid/>
  </div>
</template>
<script>
import Grid from '@/components/Grid.vue'

export default {
  name: 'Projects',
  components: {
    Grid
  }
}
</script>